/**
 * Merge department names
 * @param {string} currentDeptName - Current department name
 * @param {string} newDeptLabel - New department label
 * @returns {string} - Merged department name
 */
export const mergeDepartmentNames = (currentDeptName, newDeptLabel) => {
	return `${currentDeptName.replace(' & ', ', ')} & ${newDeptLabel}`;
};
